
import React, { useState } from 'react';
import {
  Box,
  Typography,
  FormControlLabel,
  Paper,
  RadioGroup,
  Radio,
  ToggleButton,
  ToggleButtonGroup,
  Tabs, Tab
} from '@mui/material';
import {
  AspectRatio as AspectRatioIcon,
  Person as PersonIcon,
  AutoAwesome as AutoAwesomeIcon,
  PersonOff as PersonOffIcon,
  Face as FaceIcon,
  FamilyRestroom as FamilyRestroomIcon,
} from '@mui/icons-material';
import AspectRatioForVeo from '../workspace/settingBar/VeoVideoSettings/AspectRatioForVeo';
import PeopleAndFaces from '../workspace/settingBar/VeoVideoSettings/PeopleAndFaces';
import Effects from '../workspace/settingBar/MultiAvatarVideoSettings/Effects';
import EditingTools from '../workspace/settingBar/MultiAvatarVideoSettings/EditingTools';

const Veo2Settings = ({activeVideo, veo2Videos, initializeFFmpeg, selectedTransition, setSelectedTransition}) => {
  const [activeTab, setActiveTab] = useState('ratio');

   const renderTabContent = () => {
    switch (activeTab) {
      case "ratio":
        return (
            <AspectRatioForVeo/>
        );
      case "peopleAndFaces":
        return (
         <PeopleAndFaces/>
        );
      case "editingTool":
        return (
         <EditingTools activeVideo={activeVideo} veo2Videos={veo2Videos} initializeFFmpeg={initializeFFmpeg} selectedTransition={selectedTransition} setSelectedTransition={setSelectedTransition}/>
        );
      default:
        return <AspectRatioForVeo/>;
    }
  };


  return ( 
      <>
        <Paper
      elevation={3}
      sx={{
        height: { xs: "auto", sm: "44vh", md: "44vh" },
        minHeight: { xs: "470px", sm: "470px" },
        bgcolor: "#282D51",
        borderRadius: 2,
        overflow: "hidden",
        mb: { xs: 2, sm: 0 },
        border:"", 
        display: "flex",
        flexDirection:"row",
        marginTop:"32px"
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: "divider", bgcolor: "#1a1d2e", display:"flex", flexDirection:"column",border:"" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection:"column",
            border:"" 
          }}
        >
          <Tabs
            value={activeTab}
            onChange={(e, value) => setActiveTab(value)}
            orientation="vertical"
            sx={{
              width:"174px",
              display:"flex",
              flexDirection:"column",
              marginLeft: "auto",
              marginRight: "auto",
              "& .MuiTab-root": {
                color: "#ccc",
                minHeight: { xs: 36, sm: 40 },
                fontSize: { xs: "0.75rem", sm: "0.9rem" },
                px: { xs: 0.5, sm: 1, md: 2 },
              },
              "& .Mui-selected": {
                  color: "#ffffff !important",
                  backgroundColor: "#282D51", // 🔥 Selected tab color
            },
            "& .MuiTabs-indicator": {
              display: "none", // 🔥 Hide the default blue indicator
            }
            }}
          >
            <Tab sx={{ borderBottom: "1px solid #CAC4D0", height:"117px", color:"#ffffff", fontFamily:"Inter", fontSize:"20px", fontStyle:"normal", fontWeight:400, lineHeight:"20px" }} label="VIDEO RATIO" value="ratio" />
            <Tab sx={{borderBottom: "1px solid #CAC4D0",height:"117px", color:"#ffffff", fontFamily:"Inter", fontSize:"20px", fontStyle:"normal", fontWeight:400, lineHeight:"20px" }}  label="PEOPLE AND FACES" value="peopleAndFaces" />
            <Tab  disabled={!veo2Videos || veo2Videos?.length === 0} sx={{borderBottom: "1px solid #CAC4D0",height:"117px", color:"#ffffff", fontFamily:"Inter", fontSize:"20px", fontStyle:"normal", fontWeight:400, lineHeight:"20px", "&.Mui-disabled": {
                                color: "rgba(230, 224, 233, 0.30)",
                              }, }} label="EDITING TOOLS" value="editingTool" />
            {/* <Tab sx={{height:"117px", color:"#ffffff", fontFamily:"Inter", fontSize:"20px", fontStyle:"normal", fontWeight:400, lineHeight:"20px" }} label="Settings" value="settings" /> */}
          </Tabs>
        </Box>
      </Box>
      <Box sx={{overflow: "auto", p: 3, border:"", flex: 1,  }}>
        {renderTabContent()}
      </Box>
    </Paper>
    </>
  );
};

export default Veo2Settings;